<template>
    <div>
        <b-row>
            <b-col cols="12">
                <label for="">Categoria (s) </label>
                <b-form-select
                    v-model="selectedCategories"
                    :options="selectableCategories"
                    multiple
                    :select-size="4"
                ></b-form-select>
                <div v-if="selectedCategories.length">
                    Seleccionadas:
                    <label v-for="cat in selectedCategories" :key="cat.id">
                        {{ cat.name }} ,</label
                    >
                </div>
            </b-col>
            <b-col cols="12">
                <br />
                <b-button
                    class="btn-block-xs-only"
                    v-b-toggle.collapse-2
                    variant="primary"
                    >Otra categoria</b-button
                >
                <b-collapse id="collapse-2" class="mt-2">
                    <b-card>
                        <p class="card-text">
                            <b-row>
                                <b-col cols="12" md="6" lg="6">
                                    <app-form-text-input
                                        placeholder="Nombre"
                                        id="newCategoryName"
                                        v-model="newCategory.name"
                                        :hasError="$v.newCategory.name.$error"
                                        errorMessage="Debe escribir el nombre de la categoria"
                                        @input="$v.newCategory.name.$touch()"
                                    />
                                </b-col>
                                <b-col cols="12" md="6" lg="3">
                                    <b-btn
                                        class="btn-block-xs-only"
                                        variant="primary"
                                        @click="addCategory"
                                        ><i
                                            class="fa fa-plus"
                                            aria-hidden="true"
                                        ></i>
                                        Agregar</b-btn
                                    >
                                </b-col>
                            </b-row>
                        </p>
                    </b-card>
                </b-collapse>
                <div v-if="newCategories.length">
                    Nuevas y seleccionadas:
                    <label v-for="cat in newCategories" :key="cat.id">
                        {{ cat.name }} ,</label
                    >
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import storesRepository from "../../../../../repositories/stores.repository";
import { required } from "vuelidate/lib/validators";
import { mapMutations, mapGetters } from "vuex";
import * as mutations from "../../../../../store/commitTypes.js";
export default {
    props: {
        store: {
            required: false
        },
        onSave: {
            type: Function
        }
    },
    data() {
        return {
            newCategories: [],
            selectedCategories: [],
            newCategory: {
                name: ""
            },
            categories: []
        };
    },
    validations: {
        newCategory: {
            name: { required }
        }
    },
    computed: {
        ...mapGetters(["selectedStore"]),
        selectableCategories() {
            return this.categories.filter(
                cat =>
                    !this.selectedStore.store_categories
                        .map(item => item.name)
                        .includes(cat.text)
            );
        }
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        loadCategories() {
            const sr = { ...storesRepository };
            sr.loadStoreCategories()
                .then(({ data }) => {
                    data.map(item => {
                        const object = {
                            text: item.name,
                            value: item
                        };
                        this.categories.push(object);
                    });
                })
                .catch(error =>
                    toastr.error("Error al cargar las categorias de tienda")
                );
        },
        addCategory() {
            this.$v.newCategory.$touch();
            if (this.$v.newCategory.$invalid) {
                toastr.error("Debe escribir el nombre de la nueva categoria");
                return false;
            }
            this.newCategories.push(this.newCategory);
            this.newCategory = {};
            this.$v.newCategory.$reset();
        },
        assignCategories() {
            if (this.selectedCategories.length || this.newCategories.length) {
                const payload = {};
                payload["selectedCategories"] = this.selectedCategories;
                payload["newCategories"] = this.newCategories;
                payload["storeId"] = this.store.id;

                const sr = { ...storesRepository };
                sr.assignCategories(payload)
                    .then(({ data: { status, msg, store } }) => {
                        if (status) {
                            this.setSelectedStore(store);
                            this.categories = [];
                            this.loadCategories();
                            toastr.success(msg);
                            this.cleanFields();
                            typeof this.onSave === "function" &&
                                this.onSave(store);
                        } else {
                            toastr.error(msg);
                        }
                    })
                    .catch(error => {
                        toastr.error("Error al asignar la categoria");
                    });
            } else {
                toastr.error("Debe elegir minimo una categoria");
                return false;
            }
        },
        cleanFields() {
            this.selectedCategories = [];
            this.newCategories = [];
        },
        initialize() {
            this.loadCategories();
        }
    },
    created() {
        this.initialize();
        this.$bus.$on("assign-categories-form.save", this.assignCategories);
        this.$bus.$on("assign-categories-form.clean", this.cleanFields);
    },
    beforeDestroy() {
        this.$bus.$off("assign-categories-form.save");
    }
};
</script>
